/**************************************************
 * Nombre:       Seccion_Nosotras
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {theme} from "../../Tema";
import ellas from '../../Recursos/nosotras.png'
import nosotras from '../../Recursos/img_nosottras.png'
import nosotras_cell from '../../Recursos/nosotras_cell.png'
import {REDESCLARAS} from "../../Constantes";
import {irUrl} from "../../Utilidades/irUrl";


const Seccion_Nosotras = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6, pt: 10}}

            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontSize: sCell ? 32 : 38,
                                            fontFamily: "MD Serif Display",
                                            fontWeight: 600,
                                            lineHeight: 1.1,
                                            color: theme.palette.primary.main,
                                            textAlign: sCell ? 'center' : 'left'
                                        }}
                                    >
                                        NOSOTRAS
                                    </Typography>
                                </Grid>


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>

                                    <Typography
                                        sx={{
                                            fontSize: sCell ? 22 : 22,
                                            //fontFamily: "MD Serif Display",
                                            fontWeight: 400,
                                            lineHeight: 1.1,
                                            color: theme.palette.primary.main,
                                            textAlign: sCell ? 'justify' : 'left'
                                        }}
                                    >
                                        La vida nos unió en un momento de transformación, y entendimos que la fuerza de
                                        una
                                        mujer se
                                        multiplica cuando encuentra apoyo en otra. Decidimos caminar juntas para crear
                                        un
                                        proyecto
                                        que nos devolviera al origen de lo que realmente nos llena el alma.
                                        <br/><br/>
                                        Âmevi no es solo una marca: es nuestro renacer y una invitación para que cada
                                        mujer se
                                        redescubra, brille y confíe en su propia esencia.
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 2 : 0}}>
                            <img src={ellas} width={sCell ? '90%' : '80%'} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: sCell ? 6 : 10}}>
                            <Typography
                                sx={{
                                    fontSize: sCell ? 32 : 38,
                                    fontFamily: "MD Serif Display",
                                    fontWeight: 600,
                                    lineHeight: 1.1,
                                    color: theme.palette.primary.main
                                }}
                            >
                                NUESTRO PROPÓSITO
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 10}}
                              sx={{justifyContent: 'center', mt: 2}}>

                            <Typography
                                sx={{
                                    fontSize: sCell ? 20 : 22,
                                    fontWeight: 400,
                                    lineHeight: 1.1,
                                    color: theme.palette.primary.main,
                                    textAlign: sCell ? 'justify' : 'center'
                                }}
                            >
                                En ÂMEVI, creemos que la moda es más que ropa: es una manifestación de tu esencia y una
                                expresión de tu alma viva. Nacimos con la pasión de diseñar piezas que realcen tu estilo
                                y te inspiren a vivir con autenticidad y confianza.
                                <br/><br/>
                                Cada prenda refleja nuestro compromiso con la capacidad de la moda para transformar lo
                                cotidiano en extraordinario.
                                <br/><br/>
                                Mas que moda, queremos construir una comunidad de mujeres que se atreven a brillar, a
                                sentirse seguras, y a celebrar su esencia en cada detalle.
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 8}}>

                            {REDESCLARAS.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 2, sm: 2, md: 1}}
                                          sx={{justifyContent: 'center'}}>
                                        <img
                                            onClick={() => irUrl(it.url)}
                                            src={it.iconocafe} width={50} height={'auto'} style={{cursor: 'pointer'}}/>
                                    </Grid>
                                )
                            })}

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 8, mb: 8}}>
                            <img src={sCell ? nosotras_cell : nosotras} width={'100%'} height={'auto'}/>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Nosotras    